<template>
  <div :class="classes()">
    <Modal
      size="s"
      :headline="$t('careLevelCalculator.analysis.modal.headline')"
      @close="closeAnalysisModal"
      :open="unregisteredUuid !== null"
    >
      <div :class="`${el}__content`">
        <Col center>
          <Icon name="checkbox-circle-fill" color="supportSuccess" size="xxl" />
        </Col>
        <Copy color="primaryBlue" size="l" bold centered>
          {{ $t('careLevelCalculator.analysis.modal.copy') }}
        </Copy>
      </div>
      <Col center class="u-margin__top--4">
        <Button
          :label="$t('careLevelCalculator.analysis.modal.button.label')"
          additionalIconName="arrow-right-line"
          additionalIconPos="right"
          small
          :loading="loading"
          @click="closeAnalysisModal"
        />
      </Col>
    </Modal>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';
import Icon from '@/objects/Icon/Icon';
import Button from '@/objects/Button';
import Col from '@/components/Grid/Col';
import Vue from 'vue';
import { ROUTE_API_UPDATE_CARE_LEVEL_DATA } from '@/constants/apiRoutes';
import { HEALTH_REQUEST } from '@/store/actions/health';
import { ROUTE_ANALYSE_CARE_LEVEL } from '@/constants/routes';
import Modal from '@/components/Modal/Modal';
import { mapFieldsHealth } from '@/store/mapFields';

export default {
  name: 'CareLevelAnalysisModal',
  components: { Modal, Col, Button, Icon, Copy },
  props: {},

  computed: {
    ...mapFieldsHealth(['healthUuid', 'unregisteredUuid']),
  },

  data() {
    return {
      loading: false,
      el: 'c-careLevelAnalysisModal',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },

  methods: {
    closeAnalysisModal() {
      this.loading = true;
      Vue.axios
        .post(ROUTE_API_UPDATE_CARE_LEVEL_DATA, {
          careLevelWizard: {
            personInNeedOfCareUuid: this.healthUuid,
          },
        })
        .then(() => {
          this.$store.dispatch(HEALTH_REQUEST).then(() => {
            this.loading = true;
            this.$router.push(ROUTE_ANALYSE_CARE_LEVEL);
          });
        });
    },
  },
};
</script>
